import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';

const {
  FiGrid, FiUsers, FiRefreshCw, FiBarChart2, FiUploadCloud,
  FiSettings, FiLogOut, FiMenu, FiX, FiChevronDown
} = FiIcons;

const navigation = [
  ['/dashboard', 'نظرة عامة', 'Overview', FiGrid],
  ['/leads', 'العملاء', 'Leads', FiUsers],
  ['/recoverable', 'فرص الاستعادة', 'Recovery', FiRefreshCw],
  ['/reports', 'التقارير', 'Reports', FiBarChart2],
  ['/upload', 'رفع البيانات', 'Upload Data', FiUploadCloud],
  ['/settings', 'الإعدادات', 'Settings', FiSettings]
];

export default function AppLayout({ children, path, navigate, language, setLanguage }) {
  const [menu, setMenu] = useState(false);
  const english = language === 'en';

  return (
    <div className="app-shell" dir={english ? 'ltr' : 'rtl'}>
      <button className="mobile-menu" onClick={() => setMenu(true)}><SafeIcon icon={FiMenu} /></button>
      {menu && <button className="menu-overlay" onClick={() => setMenu(false)} aria-label="إغلاق القائمة" />}
      <aside className={menu ? 'sidebar open' : 'sidebar'}>
        <div className="sidebar-top">
          <Brand />
          <button className="close-menu" onClick={() => setMenu(false)}><SafeIcon icon={FiX} /></button>
        </div>
        <nav>
          {navigation.map(([route, ar, en, icon]) => (
            <button className={path === route ? 'active' : ''} key={route} onClick={() => { navigate(route); setMenu(false); }}>
              <SafeIcon icon={icon} /><span>{english ? en : ar}</span>
            </button>
          ))}
        </nav>
        <div className="sidebar-bottom">
          <button className="clinic-switch"><span className="clinic-avatar">ا</span><span><b>عيادات ابتسامة الرياض</b><small>الخطة التجريبية</small></span><SafeIcon icon={FiChevronDown} /></button>
          <button className="profile-row"><span className="user-avatar">خ</span><span><b>خالد العتيبي</b><small>مالك العيادة</small></span></button>
          <button className="logout" onClick={() => navigate('/')}><SafeIcon icon={FiLogOut} /> {english ? 'Sign out' : 'تسجيل الخروج'}</button>
        </div>
      </aside>
      <main className="app-content">
        <div className="app-topbar">
          <button className="language-btn" onClick={() => setLanguage(english ? 'ar' : 'en')}>{english ? 'English | العربية' : 'العربية | English'}</button>
          <span className="demo-badge">وضع تجريبي</span>
        </div>
        {children}
      </main>
    </div>
  );
}